module.exports = __webpack_public_path__ + "img/drift-icon.1ee3391.png";